<template>
  <div class="PermissionSetting">
    <sp-tag-group v-model="type" class="pd-l-40 pd-t-30 tags">
      <sp-tag class="tags-font" label="Permissions">{{ $l('Permissions') }}</sp-tag>
      <sp-tag class="tags-font" label="RelatedStaff">{{ $l('RelatedStaff') }}</sp-tag>
    </sp-tag-group>
    <SpForm ref="comInfoForm" v-model="jobInfo" @submit="submit">
      <Permissions v-show="type=='Permissions'"
                   v-model="jobInfo"
                   :permission="permission"
                   :default-checked-keys="defaultCheckedKeys"
                   @setCheckedKeys="setCheckedKeys" />
      <RelatedStaff v-if="type=='RelatedStaff'" v-model="jobInfo" />
      <div class="button">
        <sp-button class="mg-b-50 mg-t-40" circle-radius="4" type="back" :label="$L('back')" :bold="-1" :width="333" :height="101" />
      </div>
    </SpForm>
  </div>
</template>

<script type="text/ecmascript-6">
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import spButton from '@/components/common/SpButton'
import Permissions from '@/components/company/permissions/Permissions'
import RelatedStaff from '@/components/company/permissions/RelatedStaff'
import {
  getOptionsJobProfessionApi,
  getOptionsJobPositionApi,
  getPermissionTreeApi,
  enterpriseJobEditApi, getEnterpriseJobDetailApi
} from '@/request/APIs/company'

import SpMessage from '@/components/common/SpMessage'
import SpForm from '@/components/common/SpForm'
export default {
  name: 'PermissionsSetting',
  nameSpace: 'company.PermissionsSetting',
  components: {
    SpForm,
    spTag,
    spTagGroup,
    spButton,
    Permissions,
    RelatedStaff
  },

  data () {
    return {
      type: 'Permissions',
      jobInfo: {
        profession: {},
        permissionIds: {}
      },

      professionOptions: [], // 职务
      positionOptions: [], // 职位

      permission: {},
      defaultCheckedKeys: [],
      checkPermissionIds: []
      // allCheck: {}
    }
  },

  computed: {
    routerQuery () {
      return this.$route.query
    }
  },

  created () {
    this.getEnterpriseCorpDetail()
  },

  mounted () {
  },

  methods: {
    // 获取职务选项 和 权限结构
    searchProfession (identity) {
      this.jobInfo.permissionIds = {}
      this.jobInfo.allCheck = {}
      getOptionsJobProfessionApi(identity, 1).then(res => {
        this.professionOptions = res.data
      })
      getPermissionTreeApi(identity).then(res => {
        this.permission = res.data
      })
    },

    // 获取职位选项
    searchPosition (profession) {
      getOptionsJobPositionApi(profession, 1).then(res => {
        this.positionOptions = res.data
      })
    },

    submit () {
      const jobInfo = JSON.parse(JSON.stringify(this.jobInfo))
      this.checkPermissionIds.push(parseInt(this.jobInfo.identity))
      const params = {
        pubPriv: jobInfo.pubPriv,
        delPriv: jobInfo.delPriv,
        permissionIds: this.checkPermissionIds.join(','),
        description: jobInfo.description
      }

      if (this.routerQuery.id) {
        params.id = this.routerQuery.id
      }

      enterpriseJobEditApi(params).then(res => {
        SpMessage({
          message: res.message,
          type: 'success'
        })
      })
    },

    // 获取职位职位详情
    getEnterpriseCorpDetail () {
      if (this.routerQuery?.id) {
        getEnterpriseJobDetailApi(this.routerQuery.id).then(res => {
          this.jobInfo = res.data

          const permissionIds = res.data.permissionIds
          const permissions = res.data.permissions
          const parentIds = permissions.map(item => item.parentId)
          // const formatPermissionIds = permissionIds.concat(parentIds).filter(item => !parentIds.includes(item))
          this.defaultCheckedKeys = permissionIds

          this.jobInfo.identity = this.jobInfo.identity.toString()
          this.searchProfession(this.jobInfo.identity)
          this.jobInfo.delPriv = this.jobInfo.delPriv.toString()
          this.jobInfo.pubPriv = this.jobInfo.pubPriv.toString()
        })
      }
    },

    setCheckedKeys (keys) {
      this.checkPermissionIds = keys
    }
  }
}
</script>

<style scoped lang="less">
.PermissionSetting {
  .opacity {
    opacity: .7;
  }
  .button {
    padding: @gap @gap*2 @gap @gap*5;
  }
}
</style>
